import { faker } from '@faker-js/faker';

const DummyData = [...Array(25)].map((_, index) => ({
    id: faker.datatype.number(),
    name: faker.name.fullName(),
    category: faker.company.name(),
    alert: faker.lorem.word(),
    clearance: faker.lorem.word(),
    quality: faker.finance.amount(),
    location: faker.address.country(),
    instrument: faker.datatype.number(),
    consignment: faker.lorem.word(),
    rest: faker.name.fullName(),
    quant: faker.date.past().toLocaleDateString(),
    limit: faker.datatype.number(),
    issue: faker.name.fullName(),
    rcdquant: faker.datatype.number(),
    action: faker.lorem.word(),
    review: faker.lorem.words(),
    created: faker.date.past().toLocaleDateString(),
    status: faker.lorem.word(),
}))


export default DummyData;